<template>
  <div class="flex flex-col sign-up-page bg-grey-background-subdued">
    <corporate-header :logo-image-url="corporateClient.logoImageURL" :slug="slug" :corporate-client-name="corporateClient.name" />
    <generic-error v-if="hasError" title="We couldn’t find that page" class="mt-64" />
    <div v-else class="mb-36 md:mb-60">
      <card class="invisible md:visible block mx-auto mt-36 md:mt-60 sign-up-card w-full" :aria-busy="isLoadingCorporateClient">
        <sign-up-form-skeleton v-if="isLoadingCorporateClient" class="visible" />
        <sign-up-form
          v-else
          :leadid="$route.query.leadid"
          :terms-of-use-link="termsOfUseLink"
          :is-years-ahead="true"
          :slug="slug"
          :privacy-policy-link="privacyPolicyLink"
          :corporate-client="corporateClient"
          class="visible"
        />
      </card>
    </div>
  </div>
</template>

<script lang="ts">
import Card from '@/components/card/Card.vue';
import CorporateHeader from '../components/CorporateHeader.vue';
import { CORPORATE_SIGNUP_FORM_QUERY } from '@/graphql/bh_benefits/queries';
import SignUpForm from './SignUpForm.vue';
import SignUpFormSkeleton from './SignUpFormSkeleton.vue';
import GenericError from '@/components/generic_error/GenericError.vue';

export default {
  name: 'BhBenefitsYearsAhead',
  components: { CorporateHeader, Card, SignUpForm, SignUpFormSkeleton, GenericError },
  data(): any {
    return {
      hasError: false,
      isLoadingCorporateClient: true,
      corporateClient: {},
    };
  },
  computed: {
    slug(): string {
      return this.$route.params.slug;
    },
    termsOfUseLink(): string {
      return 'https://www.yearsahead.com/content/terms-of-use/ ';
    },
    privacyPolicyLink(): string {
      return 'https://www.yearsahead.com/content/privacy-policy/ ';
    },
  },
  apollo: {
    corporateClient: {
      query: CORPORATE_SIGNUP_FORM_QUERY,
      variables() {
        return {
          slug: this.$route.params.slug,
        };
      },
      result({ data }) {
        this.isLoadingCorporateClient = false;
        if (data && data.corporateClient && data.corporateClient.isActive) {
          this.corporateClient = data.corporateClient;
        } else {
          this.hasError = true;
        }
      },
      error() {
        this.isLoadingCorporateClient = false;
        this.hasError = true;
      },
    },
  },
};
</script>
